export enum ShopMovieStatus {
  Unknown = 0,
  Active = 1,
  Archived = 2,
  Inactive = 3,
}
